<template>
  <HoverMenu v-if="false /*filterable*/"
             v-model="menuopen"
             :lockcloseonleave="true">
    <template v-slot:menu-activator>
      <v-btn :color="isFiltered ? 'tertiary' : ''"
             class="px-1"
             :text="menuopen || delayedmenuopen"
             :icon="!menuopen && !delayedmenuopen"
             small>
        <v-icon size="15"
                :class="menuopen ? 'mr-1' : ''"
                v-text="isFiltered ? 'mdi-filter' : 'mdi-filter-off'" />
        <v-expand-x-transition>
          <div v-if="menuopen"
               v-text="isFiltered ? $t('servicesystem.common_objects.commonterms.filtered') : $t('servicesystem.common_objects.commonterms.unfiltered')" />
        </v-expand-x-transition>
      </v-btn>
      <!--
      <v-btn v-if="isFiltered"
             :color="'error'"
             class="px-1"
             icon
             small>
        <v-icon size="17"
                v-text="'mdi-close'"
                @click="resetfilters()" />
      </v-btn>
      -->
    </template>

    <template v-slot:menu-content>
      <v-card class="pa-2">
        <h4 v-text="$t('servicesystem.common_objects.commonterms.filter_by')"
            class="mb-3 ml-2" />
        <select-li v-for="field in fieldlist"
                   :key="field.key"
                   :label="$t(field.displayString)"
                   :list="$store.getters[field.optionsgetter]"
                   :value="field.value"
                   :keyname="field.key"
                   :textkey="field.textkey ? field.textkey : 'text'"
                   :valuekey="field.valuekey ? field.valuekey : 'Id'"
                   :multiple="true"
                   :edit="true"
                   @fetch="updateValue">
        </select-li>
      </v-card>
    </template>
  </HoverMenu>
</template>


<script>
import Vue from "vue";
import HoverMenu from "@/components/Menus/HoverMenu.vue";
import SelectLi from "@/components/Inputs/SelectListItem.vue";

export default {
  name: "FilterMenu",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    inputlist: Array,
    value: Array,
    fieldlist: Array,
  },
  components: { HoverMenu, SelectLi },

  data() {
    return {
      menuopen: false,
      delayedmenuopen: false,
      filterParams: {},
      timestamp: null,
      refreshlimit: 100,
    };
  },

  mounted() {
    //this.filterParams = this.$store.getters["prefrences/Prefrence"]("FilterJobList");
  },

  methods: {
    updateValue(update) {
      Vue.set(this.filterParams, update.key, update.value);
      //this.filterParams[update.key] = update.value;

      //this.$store.dispatch("prefrences/set_prefrence", { key: "FilterJobList", value: this.filterParams });
    },

    /*
    sortColor(key) {
      if (this.sortParams.key != key) {
        return "";
      } else {
        return this.sortParams.desc ? "primary" : "primary";
      }
    },
    */

    repeaterBlock() {
      if (new Date() - this.timestamp < this.refreshlimit) {
        return true;
      } else {
        return false;
      }
    },

    filterArray() {
      var array = Object.assign([], this.inputlist);
      var filters = Object.assign({}, this.filterParams);
      const getValue = (value) => (typeof value === "string" ? value.toUpperCase() : value);
      const filterKeys = Object.keys(filters);
      var filtered = Object.assign([], array);

      if (filterKeys.length > 0) {
        filtered = filtered.filter((item) => {
          // validates all filter criteria
          return filterKeys.every((key) => {
            // ignores an empty filter
            if (!filters[key].length) return true;
            return filters[key].find((filter) => getValue(filter) === getValue(item[key]));
          });
        });
      }
      return filtered;
    },

    resetfilters() {
      this.searchterm = null;
      this.filterParams = {};
      //this.$store.dispatch("prefrences/set_prefrence", { key: "FilterJobList", value: {} });
    },
  },

  computed: {
    filterable() {
      return this.fieldlist && this.fieldlist.length > 0;
    },

    isFiltered() {
      var filtered = Object.values(this.filterParams).some((key) => key && key.length != 0);

      return filtered || this.searchterm;
    },

    filteredList() {
      return this.filterArray();
    },

    searchterm: {
      get: function () {
        return this.$store.state.filtersearchterm;
      },
      set: function (newValue) {
        this.$store.dispatch("updateFilterSearch", newValue);
      },
    },

    stored() {
      return this.$store.getters["prefrences/Prefrence"]("FilterJobList");
    },
  },

  watch: {
    filteredList: function (newval) {
      //if (!this.repeaterBlock()) {

      this.timestamp = new Date();
      this.$emit("change", newval);
      //}
    },

    stored() {
      if (Object.keys(this.stored).length < 1) {
        this.resetfilters();
      }
    },

    menuopen: function (val) {
      setTimeout(() => (this.delayedmenuopen = val), 100);
    },
  },
};
</script>


<style lang="scss" scoped>
</style>